import * as React from "react";
import PropTypes from 'prop-types';

const SvgWishlistOutlineBlack = props => {
  if (props.id !== "_svgwishlistoutlineblack") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><circle cx={20} cy={20} r={18} fill="#fff" fillOpacity={0.92} /><path fillRule="evenodd" clipRule="evenodd" d="M25.217 11.212c1.246 0 2.621.545 3.505 1.39 1.23 1.174 1.921 2.71 1.944 4.322.023 1.617-.62 3.174-1.81 4.383l-8.236 8.066-.008.009-.009.009c-.237.241-.484.368-.59.394-.054-.023-.199-.106-.482-.393l-.008-.009-.008-.009-8.233-8.066c-1.26-1.279-1.97-2.877-1.947-4.384.02-1.525.76-3.061 2.082-4.322.924-.884 2.15-1.39 3.366-1.39 2.382 0 4.077 2.356 4.09 2.376l1.092 1.57 1.141-1.54c.017-.025 1.846-2.406 4.111-2.406zm0-1.212c-3.038 0-5.216 2.941-5.216 2.941S17.953 10 14.781 10c-1.591 0-3.175.662-4.332 1.767-1.414 1.35-2.42 3.169-2.45 5.142-.027 1.97.926 3.828 2.297 5.217l8.24 8.073c.415.42.89.801 1.463.801.572 0 1.184-.38 1.598-.803l8.244-8.073c1.37-1.388 2.185-3.246 2.157-5.215-.028-1.974-.897-3.793-2.31-5.143C28.53 10.662 26.808 10 25.216 10z" fill="#202020" /></svg>;
};

SvgWishlistOutlineBlack.displayName = "_svgwishlistoutlineblack";
SvgWishlistOutlineBlack.propTypes = {
  id: PropTypes.string
};
SvgWishlistOutlineBlack.defaultProps = {
  id: ''
};
export default SvgWishlistOutlineBlack;